function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.058 9.82l6.201-8.526M3.928 15.133l10.331-5.839M5.12 21.045l12.14-1.75",
  fill: "none",
  stroke: "#FFAFA4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2
});

function SvgEyelashes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 22"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCAyMiI+PGRlZnMvPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0ibm9uemVybyIgc3Ryb2tlPSIjRkZBRkE0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS4yIj48cGF0aCBkPSJNMS4wNTggOS44Mmw2LjIwMS04LjUyNk0zLjkyOCAxNS4xMzNsMTAuMzMxLTUuODM5TTUuMTIgMjEuMDQ1bDEyLjE0LTEuNzUiLz48L2c+PC9zdmc+";
export { SvgEyelashes as ReactComponent };